import { memo } from 'react';
import { Check } from 'lucide-react';
import { WizardChip } from '../../types/suggestionWizard';
import { WIZARD_TEXT } from '../../constants/suggestionWizard';

interface ChipSelectorProps {
  chips: WizardChip[];
  selectedChips: Set<string>;
  onChipToggle: (value: string) => void;
  onSkip?: () => void;
  showSkip?: boolean;
}

/**
 * Multi-select chip selector for wizard steps.
 * Shows selectable chips with checkmark when selected.
 */
export const ChipSelector = memo<ChipSelectorProps>(({
  chips,
  selectedChips,
  onChipToggle,
  onSkip,
  showSkip = true,
}) => {
  return (
    <div className="mt-1">
      <div className="flex flex-wrap gap-1.5">
        {chips.map((chip) => {
          const isSelected = selectedChips.has(chip.value);
          return (
            <button
              type="button"
              key={chip.value}
              onClick={() => onChipToggle(chip.value)}
              className={`inline-flex items-center px-2.5 py-1 rounded-md text-[12px] font-medium border transition-all ${
                isSelected
                  ? 'bg-gray-900 text-white border-gray-900'
                  : 'bg-white text-gray-600 border-gray-200 hover:border-gray-400 hover:bg-gray-50'
              }`}
            >
              {isSelected && <Check className="w-3 h-3 mr-1" strokeWidth={2.5} />}
              {chip.label}
            </button>
          );
        })}
      </div>
      {showSkip && onSkip && (
        <button
          type="button"
          onClick={onSkip}
          className="mt-2 text-[11px] text-gray-400 hover:text-gray-600 transition-colors"
        >
          {WIZARD_TEXT.SKIP_GENERATE}
        </button>
      )}
    </div>
  );
});

ChipSelector.displayName = 'ChipSelector';

export default ChipSelector;
